import { render, staticRenderFns } from "./AdditionalSampleEvaluationSafetyForm.vue?vue&type=template&id=0f4bf13d&scoped=true&"
import script from "./AdditionalSampleEvaluationSafetyForm.vue?vue&type=script&lang=js&"
export * from "./AdditionalSampleEvaluationSafetyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4bf13d",
  null
  
)

export default component.exports